import AdminRoutes from "./authentication/AdminRoutes";
import PublicRoutes from "./authentication/PublicRoutes";

function App() {
  return (
    <>
      <PublicRoutes />
      <AdminRoutes />
    </>
  );
}

export default App;
